import React from 'react';
import Button from '@material-ui/core/Button';
import AdUploader from './AdUploader';
import UserContext from '../common/UserContext';
import {IFileWithMeta} from 'react-dropzone-uploader';
import {makeStyles} from '@material-ui/core/styles';
import {v4 as uuid} from 'uuid';

type AdUploadFormProps = {
  adFile: File | undefined,
  setAdFile: (_: File | undefined) => void,
  setAdFileKey: (_: string) => void,
  nextStep: () => void,
  prevStep: () => void
};

const useStyles = makeStyles(theme => ({
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1)
  }
}));

const AdUploadForm: React.FC<AdUploadFormProps> = props => {
  const {user, apiToken} = React.useContext(UserContext);
  const [canNextStep, setCanNextStep] = React.useState(false);
  const classes = useStyles();
  const adFileKey = uuid();

  function handleDone({file}: IFileWithMeta): void {
    props.setAdFileKey(adFileKey);
    props.setAdFile(file);
    setCanNextStep(true);
  }

  function handleRemove(): void {
    props.setAdFile(undefined);
    setCanNextStep(false);
  }

  return (
    <>
      <AdUploader
        userIdToken={apiToken || 'unknown-token'}
        adFileKey={adFileKey}
        initialfile={props.adFile}
        canRemove={true}
        onDone={handleDone}
        onRemove={handleRemove}
      />

      <div className={classes.buttons}>
        <Button onClick={props.prevStep} className={classes.button}>Back</Button>
        <Button
          variant="contained"
          color="primary"
          onClick={props.nextStep}
          className={classes.button}
          disabled={!canNextStep}>Next</Button>
      </div>
    </>
  );
};
export default AdUploadForm;
